
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { SistemaFormValues } from "../schemas/sistemaFormSchema";

interface PerformanceFieldsProps {
  form: UseFormReturn<SistemaFormValues>;
}

export const PerformanceFields = ({ form }: PerformanceFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField
          control={form.control}
          name="eficiencia"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Eficiência (0.7 - 1.0)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0.7" max="1" {...field} placeholder="0.85" />
              </FormControl>
              <FormDescription>
                Eficiência média do sistema, valores típicos entre 0.7 e 1.0
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="perdas"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Perdas (0 - 0.3)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0" max="0.3" {...field} placeholder="0.15" />
              </FormControl>
              <FormDescription>
                Perdas elétricas e por sombreamento, valores típicos entre 0 e 0.3
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField
          control={form.control}
          name="fatorSimultaneidade"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Fator de Simultaneidade (0.8 - 1.0)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0.8" max="1" {...field} placeholder="0.9" />
              </FormControl>
              <FormDescription>
                Fator de simultaneidade de uso, valores típicos entre 0.8 e 1.0
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="fatorCapacidade"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Fator de Capacidade (0.15 - 0.25)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0.15" max="0.25" {...field} placeholder="0.18" />
              </FormControl>
              <FormDescription>
                Fator de capacidade, valores típicos entre 0.15 e 0.25
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};
